
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/express-pass",
      function () {
        return require("private-next-pages/express-pass/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/express-pass"])
      });
    }
  